import { FormEvent } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import useCoachList from '@nkr/store/microsites/hooks/use-coach-list';
import { styles } from './styles';

interface IProps {
    year: number;
    coachId: number;
    isSuperAdmin: boolean;
    onYearChange: (year: number) => void;
    onCoachChange: (coachId: number) => void;
    onExport: () => void;
}

const getYears = (): number[] => {
    const start = 2020;
    const current = new Date().getFullYear();
    const years: number[] = [];
    for (let y = current; y >= start; y--) {
        years.push(y);
    }
    return years;
};

const Filter = (props: IProps) => {
    const { coachList } = useCoachList();

    const handleYearChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onYearChange(parseInt(e.currentTarget.value));
    };

    const handleCoachChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCoachChange(parseInt(e.currentTarget.value));
    };


    return (
        <div className='well well-sm' style={styles.filterBar}>
            <div style={styles.filterLeft}>
                <div style={styles.filterGroup}>
                    <span style={styles.filterLabel}>Year:</span>
                    <FormControl
                        componentClass='select'
                        value={props.year}
                        onChange={handleYearChange}
                    >
                        {getYears().map(y =>
                            <option key={y} value={y}>{y}</option>
                        )}
                    </FormControl>
                </div>

                {props.isSuperAdmin && (
                    <div style={styles.filterGroup}>
                        <span style={styles.filterLabel}>Coach:</span>
                        <FormControl
                            componentClass='select'
                            value={props.coachId}
                            onChange={handleCoachChange}
                        >
                            <option value={0}>- All Coaches -</option>
                            {coachList.map(coach =>
                                <option key={coach.id} value={coach.contactId}>{coach.firstName} {coach.lastName}</option>
                            )}
                        </FormControl>
                    </div>
                )}
            </div>

            <Button onClick={props.onExport}>Export</Button>
        </div>
    );
};

export default Filter;
